import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  YES_WI_EVIDENCE_ADDED,
  NOT_TESTED_ADD_REASON_WI,
  NA_NO_TEST_ENVIROMENT,
  NA_HARDWARE_REPLACEMENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const fieldId = 'testing-status';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = null;

const vFParams = {
  fieldTitle: 'Testing status:',
  placeholder: 'Please select',
};


const riskLevelParams = {
  weight: 1,
  score: {
    [YES_WI_EVIDENCE_ADDED]: 1,
    [NOT_TESTED_ADD_REASON_WI]: 5,
    [NA_NO_TEST_ENVIROMENT]: 2,
    [NA_HARDWARE_REPLACEMENT]: 2,
  },
};



const testingStatus = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_DROPDOWN,
};

export { testingStatus };
